export const backend = (): string => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    return 'https://ecommerceserver-7ucs.onrender.com/api/admin/'
  } else {
    return 'https://ecommerceserver-7ucs.onrender.com/api/admin/'
  }
}
